<template>
  <v-checkbox
    class="list_counter_validator my-2 ml p-0"
    :input-value="valid"
    :rules="[(v) => !!v || $t('formulaires.provinceEtCategorieIncompatibles')]"
  ></v-checkbox>
</template>

<script>
export default {
  props: {
    estProvinceQC: { type: Boolean },
    estCategorieHQ: { type: Boolean },
    estInactif: { type: Boolean }
  },
  computed: {
    valid() {
      return !(this.estProvinceQC && this.estCategorieHQ && !this.estInactif)
    }
  }
}
</script>

<style>
</style>